import * as css from './fullDescriptionStep.css';
import {useFormikContext, useField} from 'formik';
import StepRight from '../stepRight/StepRight';
import StepContext from '../stepContext/StepContext';
import StepLeft from '../StepLeft/StepLeft';
import {TEvent} from '../../../../redux/event/event.type';
import TextEditor from '../../../../component/textEditor/TextEditor';
import {useRef} from 'react';
import {convertTextBeforeSave} from '../../../../component/textEditor/TextEditorHelpers';
import {updateEvent} from '../../../../redux/event/eventActions';

export const onClickFullDescription = async (changedValues) => {
    updateEvent({fullDescription: changedValues?.fullDescription}).then();
};

function FullDescriptionStep() {
    const form = useFormikContext() as {values: TEvent};
    const fullDescription=form.values.fullDescription;
    const quillRef = useRef(null);
    const [, , helpers] = useField('fullDescription');

    const onKeyDown=e=>{
        if(e.key==='Enter')
            e.stopPropagation();
    };
    const handleChange=()=>{
        const htmlValue = convertTextBeforeSave(quillRef);
        helpers.setValue(htmlValue);
    };

    return (
        <css.wrapAll>
            <StepContext>
                <StepRight name={'fullDescription'} >
                    <css.Textarea onKeyDown={onKeyDown} data-cy="new-event-full-description-editor">
                        <TextEditor
                            quillRef={quillRef}
                            defaultText={fullDescription || ''}
                            onChange={handleChange}
                            onSave={handleChange}
                            dependencies={[]}
                            showToolbar={true}
                            expanded={true}
                            disable={{alignLeft: true}}
                            variablesDataCy="new-event-variables-dropdown"
                        />
                    </css.Textarea>
                </StepRight>
                <StepLeft name={'fullDescription'}>{undefined}</StepLeft>
            </StepContext>     
        </css.wrapAll>
    );
}

export default FullDescriptionStep;
